export const PLEASE_FILL_CURRENT_PASSWORD = "Please fill in Current  Password";
export const PLEASE_FILL_NEW_PASSWORD = "Please fill in New Password";
export const PLEASE_FILL_VERIFY_PASSWORD = "Please fill in New Password Again";
